import portaro from '../portaro';

portaro.factory('Offer', ['$resource',
    function($resource) {
        return $resource(contextPath + '/api/offers/:id', {id: '@id'});
    }]);